import './footer.scss';

const FooterComponent = {
    template: require('./footer.html'),
    controller: () => {},
};

export default angular.module('app.footer', [])
    .component('footer', FooterComponent)
    .name;




// WEBPACK FOOTER //
// ./src/app/components/footer/footerComponent.js